import { render, staticRenderFns } from "./default.vue?vue&type=template&id=0cdcc57e&"
import script from "./default.vue?vue&type=script&lang=js&"
export * from "./default.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LayoutHeader: require('/Users/rabbitfoot/Bitbucket/garden-eight-v3/nuxt/components/layout/header.vue').default,LayoutFooter: require('/Users/rabbitfoot/Bitbucket/garden-eight-v3/nuxt/components/layout/footer.vue').default})
